import { RouterProvider } from 'react-router-dom';

import { ApplicationErrorBoundary } from '@/app/ApplicationErrorBoundary';
import { AppProviders } from '@/app/AppProviders';
import { router } from '@/app/router';

export function App() {
  return (
    <ApplicationErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </ApplicationErrorBoundary>
  );
}
